// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2NePI","inner":"Form_inner__1e12G","range":"Form_range__VLqzw","name":"Form_name__3303-","actions":"Form_actions__13cWu"};